const getters = {
  full_screen: state => state.home.full_screen
}
export default getters
